/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TopBar_user = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user" | "CartNav_user" | "Notifications_user">;
    readonly " $refType": "TopBar_user";
};
export type TopBar_user$data = TopBar_user;
export type TopBar_user$key = {
    readonly " $data"?: TopBar_user$data;
    readonly " $fragmentRefs": FragmentRefs<"TopBar_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TopBar_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "AccountNav_user",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "CartNav_user",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "Notifications_user",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '8b9d906e238b5be75ac5e5f3ac98ae6e';
export default node;
